import styled from "styled-components";
import { BRAND, BRAND_DARK } from "@streeteasy/design-system/colors";
import { Body, Caps } from "@streeteasy/design-system/typography";

export const CTAContainer = styled.div`
  margin-top: 4px;
`;

export const CTAText = styled(Body)`
  margin-bottom: 4px;
`;

export const ViewButton = styled(Caps).attrs({
  as: "button"
})`
  color: ${BRAND};
  background: transparent;
  border: none;
  padding: 0;

  &:hover {
    color: ${BRAND_DARK};
  }

  &:active {
    color: ${BRAND};
  }
`;
